var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkmode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.375 7.125L7 8.125L6 8.5L7 8.875L7.375 9.875L7.75 8.875L8.75 8.5L7.75 8.125L7.375 7.125Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87508 1.16669L9.37508 2.50002L8.04175 3.00002L9.37508 3.50002L9.87508 4.83335L10.3751 3.50002L11.7084 3.00002L10.3751 2.50002L9.87508 1.16669Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 0L2.18182 2.18182L0 3L2.18182 3.81818L3 6L3.81818 3.81818L6 3L3.81818 2.18182L3 0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkmode);
export default __webpack_public_path__ + "static/media/darkmode.85cef370.svg";
export { ForwardRef as ReactComponent };